// this file was auto-generated by rake i18n:generate_js.
// you probably shouldn't edit it directly
import mergeI18nTranslations from '@canvas/i18n/mergeI18nTranslations.js';

// we use JSON.parse here instead of just loading it as a javascript object literal
// because according to https://v8.dev/blog/cost-of-javascript-2019#json that is faster
mergeI18nTranslations(JSON.parse("{\"ru\":{\"expand_global_navigation_2c28d5d4\":\"Расширить глобальную навигацию\",\"minimize_global_navigation_2d839351\":\"Минимизировать глобальную навигацию\"},\"uk\":{\"expand_global_navigation_2c28d5d4\":\"Розгорнути глобальну навігацію\",\"minimize_global_navigation_2d839351\":\"Мінімізувати глобальну навігацію\"}}"));
